export default "__VITE_ASSET__3dc5e669__"